import {
   Button, Dialog,
   DialogActions,
   DialogContent,
   DialogTitle,
   MenuItem,
   Select,
   TextField,
   Typography
} from '@material-ui/core';
import React from 'react';

const MultiLineTextField = require('../commonControls.jsx.js').MultiLineTextField;

export function ManiaSubmitDialog(props){
   return(
      <Dialog open={props.open}>
         <DialogTitle>Submit µPub to Tournament</DialogTitle>
         <DialogContent>
            <TextField
               multiline={true}
               label="Title"
               fullWidth
               value={props.selectedCardTitle}
               onChange={props.onTitleChanged}
            />
            <hr/>
            <MultiLineTextField data={props.selectedCardReason} label="Justification for Adding"
                                onChange={props.onSelectedCardReasonChanged} maxLength='1000' rows={3}/>
         </DialogContent>
         <DialogActions>
            <Button
               disabled={props.selectedCardReason.trim().length === 0 ||  props.selectedCardTitle.trim().length === 0}
               onClick={props.onSubmit}
            >
               Submit
            </Button>
            <Button onClick={props.onCancel}>Cancel</Button>
         </DialogActions>
      </Dialog>
   )
}
